import MyStatementsBar from './MyStatementsBar';

export default MyStatementsBar;
